import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-layout-empty',
  templateUrl: './layout-empty.component.html',
  styleUrls: ['./layout-empty.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [FuseLoadingBarComponent, RouterOutlet],
})
export class LayoutEmptyComponent implements OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor() {}

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
